import type {Activity} from 'types';

export const perDay = (activity: Activity | undefined) => {
  return activity?.repeatType === 'PerDay' ? activity.repeatCount : activity?.repeatCountPerDay;
};
